/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useForm } from "react-hook-form";
import { Button, Form, Label } from "reactstrap";
import { useContext } from "react";
import { AccountContext, CaptivePortalContext, ContextUpdater, CreateLoginPageContext } from "../../../context/ContextProvider";
import { requestUploadCaptivePortalImage } from "../../../context/RequestManager";
import { acceptImage } from "../../../provisioning/ProvisioningUtil";
import FormInput from "../../../provisioning/elements/FormInput";
import CenterModal from "../../../elements/CenterModal";
import debug from "../../../util/constants/Debug";

const ModalImageUploadForm = ({type, isOpen, toggle, onUploaded}) => {
  // global contexts
  const updateContexts = useContext(ContextUpdater);
  const accountContext = useContext(AccountContext);
  const captivePortalContext = useContext(CaptivePortalContext);
  const createLoginPageContext = useContext(CreateLoginPageContext);

  const imageList = captivePortalContext.imageList;

  // const isAdmin = (accountContext.admin ?? false) || (accountContext.subAdmin ?? false);
  // const uploadClientId = isAdmin ? null : accountContext.clientId;
  const uploadClientId = createLoginPageContext.clientScope;
  const readOnly = accountContext.permissions?.readOnly ?? false;

  // form state
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit"
  });

  // handlers
  const handleOnSubmit = (data) => {
    // close modal view
    toggle();

    if (readOnly) { 
      return;
    }

    // upload image
    requestUploadCaptivePortalImage({
      context: updateContexts,
      token: accountContext.token,
      file: data.file[0],
      name: data.name,
      type: type,
      clientId: uploadClientId,
      completion: (results) => {
        // check for errors
        const error = results.error;

        // check for error
        if (error != null) {
          debug.warn("Error: " + error);
          alert("Error uploading file");
        }

        // if uploaded callback, return new url
        if (onUploaded) {
          const newImageList = results.captivePortal?.imageList;
          const newImage = newImageList?.find((image) => image.name === data.name);
          if (newImage) {
            onUploaded(newImage);
          }
        }
      }
    })
  };

  const validateName = (name) => {
    if (imageList.some((image) => image.name === name)) {
      return "Image name already exists";
    }
    return true;
  };

  // helpers
  const inputProps = {
    register: register,
    errors: errors,
    required: true
  };

  return (
    <CenterModal isOpen={isOpen} toggle={toggle}>
      <Form onSubmit={handleSubmit(handleOnSubmit)} style={{ minWidth: "320px" }}>
        <Label className="text-center" tag="h3">Upload Image</Label>
        <br />
        <FormInput name="file" text="Image File" type="file" accept={acceptImage} {...inputProps} />
        <br />
        <FormInput name="name" text="Image Name" validate={validateName} {...inputProps} />
        <div className="pt-4 d-flex justify-content-center">
          <Button type="submit">Upload</Button>
        </div>
      </Form>
    </CenterModal>
  );
};

export default ModalImageUploadForm;
